import { NgModule } from '@angular/core';
import { YearDirective } from './year.directive';

@NgModule({
    declarations: [
        YearDirective
    ],
    exports: [
        YearDirective
    ]
})
export class YearDirectiveModule { }
